<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 class="pa-1" sm10 offset-sm1 md8 offset-md2>
          <v-card>
            <v-card-title class="py-1">
              Laboratory Services Providers
              <v-spacer></v-spacer>
              <v-btn @click="addLab = !addLab" small color="secondary">Add</v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="laboratories" :search="filterBy" :headers="headers" dense>
                <template v-slot:[`item.name`]="{ item }">
                  <td><inertia-link :href="'/laboratories/' + item.id" v-html="item.name"></inertia-link></td>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <td>
                    <v-btn text icon small :title="'Delete ' + item.name" @click="deleteLab(item)">
                      <v-icon color="red">{{ icons.delete }}</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="pt-0 pb-0">
              <v-spacer></v-spacer>
              <inertia-link href="/laboratory_tests">Laboratory Tests</inertia-link>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <modal-dialog :open="addLab" @close="addLab = false">
        <template slot="title">Add Provider</template>
        <create-lab class="" @saved="addLab = false"></create-lab>
      </modal-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const CreateLab = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "laboratories" */ '@/Components/Laboratories/create')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')

  export default {
    name: 'Laboratories',
    metaInfo () {
      return {
        title: 'Laboratories',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    components: {
      CreateLab,
      ModalDialog,
    },
    layout,
    props: [
      'laboratories'
    ],
    data () {
      return {
        filterBy: '',
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Location', value: 'location' },
          { text: 'Phone', value: 'phone' },
          { text: 'Email', value: 'email' },
          { text: 'Related Tests', value: 'laboratory_tests_count' },
          { text: 'Actions', value: 'actions' }
        ],
        addLab: false
      }
    },
    methods: {
      deleteLab (lab) {
        if (confirm('You are about to delete ' + lab.name + ' and all related tests. Are you sure?')) {
          this.$inertia.delete('/laboratories/' + lab.id, {
            preserveScroll: true
          })
        }
      }
    },
  }
</script>
